import { render } from "./BidangTangkap.vue?vue&type=template&id=6b95a5be"
import script from "./BidangTangkap.vue?vue&type=script&lang=js"
export * from "./BidangTangkap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__